import INotification from "../interfaces/INotification";
import useFocusShape from "./useFocusShape";
import useNotificationsInsideShape from "./useNotificationsInsideShape";

export default function (notifications: INotification[]): INotification[] {
    return useNotificationsInsideShape(notifications, useFocusShape());
}